import React from 'react';
import { Button, ButtonProps } from 'antd';
import styles from './PrimaryButton.module.css';

type PrimaryButtonProps = Omit<ButtonProps, 'type' | 'danger' | 'ghost'>;

/** The date picker's primary action. The app's primary buttons are black
 * (see CustomButton); antd's own `type='primary'` follows `colorPrimary`, which
 * is the blue accent used for links and focus, so a bare antd primary button
 * here renders blue. Use this instead of `<Button type='primary'>`. */
const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  className,
  ...props
}) => (
  <Button
    {...props}
    type='primary'
    className={[styles.primary, className].filter(Boolean).join(' ')}
  />
);

export default PrimaryButton;
